import * as React from "react";
const SvgFiRrFileAi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-file-ai_svg__a)">
      <path d="M7.515 5.008a.744.744 0 0 0-1.382.013l-1.977 5.187a.626.626 0 0 0 1.168.448l.34-.89h2.31l.335.888a.625.625 0 1 0 1.17-.441zM6.14 8.514l.684-1.8.68 1.8zM11.232 4.544a.626.626 0 0 0-.625.625v5.262a.625.625 0 0 0 1.25 0V5.169a.625.625 0 0 0-.625-.625" />
      <path d="M19 0H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h11.343a4.97 4.97 0 0 0 3.536-1.464l2.656-2.658A4.97 4.97 0 0 0 24 16.343V5a5.006 5.006 0 0 0-5-5M2 19V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10h-4a3 3 0 0 0-3 3v4H5a3 3 0 0 1-3-3m16.465 2.122c-.402.401-.91.679-1.465.8V18a1 1 0 0 1 1-1h3.925a3 3 0 0 1-.8 1.464z" />
    </g>
    <defs>
      <clipPath id="fi-rr-file-ai_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFileAi;
